import { TemplateResult } from 'lit';
import type { SlotTemplateResult } from './types.js';
export const toSlotTemplateResult = (template: TemplateResult, hasSlot: boolean): SlotTemplateResult => {
  const _template = template as SlotTemplateResult;
  _template.hasSlot = hasSlot;
  return _template;
};